"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPresetNames = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@ag-grid-community/react");
const api_1 = require("../api");
const errorNotification_1 = require("../errorNotification");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const row_grouping_1 = require("@ag-grid-enterprise/row-grouping");
const set_filter_1 = require("@ag-grid-enterprise/set-filter");
const multi_filter_1 = require("@ag-grid-enterprise/multi-filter");
const menu_1 = require("@ag-grid-enterprise/menu");
const NewPresetForm_1 = __importDefault(require("../forms/NewPresetForm"));
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const PresetsGroupRenderer_1 = __importDefault(require("../components/PresetsGroupRenderer"));
const Modal_1 = __importDefault(require("../components/Modal"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const utils_1 = require("../Auth/utils");
const AuthContext_1 = require("../Auth/AuthContext");
const getPresetNames = (column) => {
    const names = {
        'pr': 'Präs.Bereich',
        'schachtschneider_1': 'Schacht-Etiketten',
        'hameter_2': 'Überwinterung',
        'hameter_3': 'Hameter-Etiketten',
        'blutenfarbe': 'Blütenfarbe',
        'blattfarbe': 'Blattfarbe',
    };
    return names[column] ? names[column] : column;
};
exports.getPresetNames = getPresetNames;
const Presets = () => {
    const [gridApi, setGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows, setRows] = (0, react_1.useState)([]);
    const [showNewPresetForm, setShowNewPresetForm] = (0, react_1.useState)(false);
    const [newColumn, setNewColumn] = (0, react_1.useState)('');
    const presetApi = new api_1.PresetApi;
    const { user } = (0, AuthContext_1.useAuth)();
    if (!(0, utils_1.hasRole)(user, ['admin'])) {
        return null;
    }
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
        row_grouping_1.RowGroupingModule,
        set_filter_1.SetFilterModule,
        multi_filter_1.MultiFilterModule,
        menu_1.MenuModule,
    ];
    const defaultColDef = {
        flex: 1,
        minWidth: 150,
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
    };
    const gridOptions = {
        enableRangeSelection: true,
        rowHeight: 40,
        getRowNodeId: (data) => {
            return data.id;
        },
        autoGroupColumnDef: {
            headerName: 'group',
            minWidth: 200,
            cellRendererParams: {
                suppressCount: true,
            },
        },
        groupUseEntireRow: true,
        groupDefaultExpanded: 1,
        groupRowRendererParams: {
            innerRenderer: 'PresetsGroupRenderer',
            handleAddNew: (column) => {
                setShowNewPresetForm(true);
                setNewColumn(column);
            }
        }
    };
    const columns = [
        {
            field: 'column',
            headerName: 'Spalte',
            editable: false,
            rowGroup: true,
            showRowGroup: true,
            filter: 'agMultiColumnFilter',
            valueFormatter: params => {
                return (0, exports.getPresetNames)(params.value);
            }
        },
        {
            field: 'value',
            headerName: 'Wert',
            filter: false,
            editable: false,
        },
        {
            field: 'floramedia_code',
            headerName: 'Floramedia code',
            filter: false,
            editable: (params) => {
                return params.node.data.column === 'etikett';
            },
            cellClass: (params) => {
                return params.node.data.column === 'etikett' ? '' : 'noteditable';
            },
        },
    ];
    function onGridReady(params) {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const { items } = await presetApi.index();
                setRows(items);
            }
            catch (e) {
                (0, errorNotification_1.notifyError)(e.message);
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const cellValueChanged = async (event) => {
        const { data } = event;
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                await presetApi.update(id, { column, value: newValue });
            }
            catch (error) {
                if (error.response && error.response.status === 422) {
                    for (const [key, value] of Object.entries(error.response.data.errors)) {
                        // @ts-ignore
                        (0, errorNotification_1.notifyError)(value[0]);
                    }
                }
                else {
                    (0, errorNotification_1.notifyError)(error.message);
                }
            }
        }
    };
    const handleCreated = (item) => {
        setShowNewPresetForm(false);
        const transaction = gridApi.applyTransaction({ addIndex: 0, add: [item] });
        (0, errorNotification_1.notify)('success', 'Wert erstellt.');
        gridApi.flashCells({
            rowNodes: transaction.add,
        });
    };
    const getContextMenuItems = (params) => {
        const { node } = params;
        if (!node.data)
            return [];
        return [
            {
                name: 'Wert "' + node.data.value + '" löschen',
                action: async function () {
                    try {
                        await presetApi.delete(node.data.id);
                        params.api.applyTransaction({ remove: [node] });
                        (0, errorNotification_1.notify)('success', 'Wert gelöscht');
                    }
                    catch (error) {
                        (0, errorNotification_1.notifyError)(error);
                    }
                },
            },
        ];
    };
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Wertetabellen")),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Wertetabellen"))),
        react_1.default.createElement("div", { id: 'presets-grid', className: "zas-theme zas-grid ag-theme-balham w-full" },
            react_1.default.createElement(react_2.AgGridReact
            // @ts-ignore
            , { 
                // @ts-ignore
                domLayout: 'autoHeight', modules: gridModules, disableStaticMarkup: true, onGridReady: onGridReady, rowSelection: 'single', suppressRowClickSelection: true, suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, rowData: rows, getRowNodeId: (data) => data.id, getContextMenuItems: getContextMenuItems, onCellValueChanged: cellValueChanged, frameworkComponents: {
                    'PresetsGroupRenderer': PresetsGroupRenderer_1.default,
                } }),
            react_1.default.createElement(Modal_1.default, { isOpen: showNewPresetForm, onRequestClose: () => setShowNewPresetForm(false) },
                react_1.default.createElement(NewPresetForm_1.default, { column: newColumn, handleCreated: handleCreated, handleCancel: () => setShowNewPresetForm(false) })))));
};
exports.default = Presets;
